import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:my-24 mt-3 grid gap-y-5" }
const _hoisted_2 = {
  id: "users-header",
  class: "flex items-center justify-between"
}
const _hoisted_3 = { class: "md:flex items-center gap-3 relative" }
const _hoisted_4 = {
  key: 0,
  ref: "ActionOptions",
  class: "bg-white w-72 py-2 shadow-md rounded-md absolute top-12 right-0 z-50"
}
const _hoisted_5 = { class: "text-[14px]" }
const _hoisted_6 = { class: "text-[14px]" }
const _hoisted_7 = { class: "text-[14px] ml-1" }
const _hoisted_8 = { class: "bg-white rounded-lg border border-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImportModal = _resolveComponent("ImportModal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.showImportModal)
      ? (_openBlock(), _createBlock(_component_ImportModal, {
          key: 0,
          showModal: _ctx.showImportModal,
          onOnCloseImportModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showImportModal = false)),
          onOnUpdateTable: _ctx.usersPaginated
        }, null, 8, ["showModal", "onOnUpdateTable"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Usuários", en: "Users" })), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          id: "actions-btn",
          label: `${_ctx.$t('labels.generic', { pt: 'Ações', en: 'Actions' })}`,
          class: "btn-primary p-button-sm",
          icon: "pi pi-plus",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openActionOptions()))
        }, null, 8, ["label"]),
        (_ctx.showActionOptions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Button, {
                id: "add-user-btn",
                class: "btn-simple p-button-sm w-full gap-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go.redirectTo('formUser')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { name: "md-personaddalt-outlined" }),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Cadastrar usuário",
                  en: "Add user",
                })), 1)
                ]),
                _: 1
              }),
              (_ctx.user.role === 'ADMINISTRATOR')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    id: "add-user-btn",
                    class: "btn-simple p-button-sm w-full gap-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openImportModal()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { name: "md-uploadfile-round" }),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Importar usuários",
                  en: "Users imports",
                })), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                id: "download-template-btn",
                class: "btn-simple",
                onClick: _ctx.downloadCSVTemplate
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { name: "md-insertdrivefile-round" }),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Baixar modelo de importação",
                  en: "Download import model",
                })), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 512))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Table, {
        slotData: _ctx.users,
        columns: _ctx.columns,
        actions: _ctx.actions,
        loading: _ctx.loading,
        params: _ctx.params,
        filters: _ctx.filters,
        hasStatus: true,
        onOnEdit: _cache[9] || (_cache[9] = (e) => _ctx.goToEdit(e)),
        onOnChangeStatus: _cache[10] || (_cache[10] = (e) => _ctx.changeUserStatus(e)),
        onOnPaginate: _cache[11] || (_cache[11] = ($event: any) => (_ctx.paginate($event))),
        onOnToggleFilter: _cache[12] || (_cache[12] = (e, type) => _ctx.toggleFilter(e, type)),
        onOnFilter: _cache[13] || (_cache[13] = ($event: any) => (_ctx.filterFor())),
        onOnClearFilter: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearFilter()))
      }, {
        filters: _withCtx(() => [
          (_ctx.filterType == 'name')
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                modelValue: _ctx.filters.name,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.name) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.filterType == 'login')
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 1,
                modelValue: _ctx.filters.email,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.email) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.filterType == 'organization')
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 2,
                modelValue: _ctx.filters.organization,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.organization) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.filterType == 'role')
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 3,
                modelValue: _ctx.filters.role.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.role.value) = $event)),
                options: _ctx.filters.role.options,
                optionLabel: "name",
                optionValue: "code",
                placeholder: "Selecione o tipo"
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.filterType == 'status')
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 4,
                modelValue: _ctx.filters.status.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.status.value) = $event)),
                options: _ctx.filters.status.options,
                optionLabel: "name",
                optionValue: "code",
                placeholder: "Selecione o status"
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["slotData", "columns", "actions", "loading", "params", "filters"])
    ])
  ]))
}